(function () {
  // This file is loaded by every wl-collection-mui-* section, so guard against running more than once.
  if (window.__wlMuiFadeinInitialized) return;
  window.__wlMuiFadeinInitialized = true;

  var TARGET_CLASS = "wl-mui-fadein";
  var ACTIVE_CLASS = "wl-mui-fadein--active";
  var READY_CLASS = "wl-mui-fadein--ready";
  // An element fades in once it enters the area between the viewport top and 80% of the viewport height.
  var VISIBLE_RATIO = 0.8;

  function supportsReducedMotion() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function setInitialStyle(el) {
    el.style.opacity = "0";
    el.style.transform = "translate3d(0px, 2rem, 0px) scale(1.02)";
    el.style.willChange = "opacity, transform";
    el.style.transition =
      "opacity 1000ms cubic-bezier(0.25, 0.1, 0.25, 1) 0ms, transform 1000ms cubic-bezier(0.25, 0.1, 0.25, 1) 0ms";
  }

  function setActiveStyle(el) {
    el.style.opacity = "1";
    el.style.transform = "translate3d(0px, 0px, 0px) scale(1)";
    el.style.transition =
      "opacity 1500ms cubic-bezier(0.25, 0.1, 0.25, 1) 60ms, transform 1620ms cubic-bezier(0.25, 0.1, 0.25, 1) 0ms";
  }

  // Once the fade-in has finished, drop will-change so large elements no longer hold a compositor layer.
  function onTransitionEnd(event) {
    var el = event.currentTarget;
    if (event.target !== el || event.propertyName !== "opacity") return;
    if (el.classList.contains(ACTIVE_CLASS)) {
      el.style.willChange = "auto";
    }
  }

  function prepElement(el) {
    if (el.classList.contains(READY_CLASS)) return;
    setInitialStyle(el);
    el.addEventListener("transitionend", onTransitionEnd, false);
    el.classList.add(READY_CLASS);
  }

  function shouldRemove(el) {
    if (!el.hasAttribute("data-remove")) return true;
    return String(el.getAttribute("data-remove")).toLowerCase() !== "false";
  }

  function activate(el) {
    if (el.classList.contains(ACTIVE_CLASS)) return;
    el.classList.add(ACTIVE_CLASS);
    setActiveStyle(el);
  }

  function deactivate(el) {
    if (!shouldRemove(el) || !el.classList.contains(ACTIVE_CLASS)) return;
    el.classList.remove(ACTIVE_CLASS);
    setInitialStyle(el);
  }

  // IntersectionObserver evaluates the live layout, so later layout changes (images loading,
  // Swiper autoHeight updates, fonts) never leave an element stuck at opacity 0.
  // The previous implementation cached offsetTop at init and only re-measured on resize.
  var observer = null;

  function getObserver() {
    if (observer) return observer;
    observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            activate(entries[i].target);
          } else {
            deactivate(entries[i].target);
          }
        }
      },
      {
        root: null,
        rootMargin: "0px 0px -" + Math.round((1 - VISIBLE_RATIO) * 100) + "% 0px",
        threshold: 0,
      }
    );
    return observer;
  }

  function showImmediately(el) {
    el.style.opacity = "1";
    el.style.transform = "none";
    el.classList.add(READY_CLASS);
    el.classList.add(ACTIVE_CLASS);
  }

  // Prepare and observe every target not handled yet (also used for sections rendered later).
  function scan() {
    var targets = document.getElementsByClassName(TARGET_CLASS);
    var useObserver = "IntersectionObserver" in window && !supportsReducedMotion();

    for (var i = 0; i < targets.length; i++) {
      var el = targets[i];
      if (el.classList.contains(READY_CLASS)) continue;
      if (!useObserver) {
        showImmediately(el);
        continue;
      }
      prepElement(el);
      getObserver().observe(el);
    }
  }

  var scanScheduled = false;
  function scheduleScan() {
    if (scanScheduled) return;
    scanScheduled = true;
    window.requestAnimationFrame(function () {
      scanScheduled = false;
      scan();
    });
  }

  function init() {
    scan();
    new MutationObserver(scheduleScan).observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener("shopify:section:load", scheduleScan);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
